import React, { useEffect, useState } from "react";
import {
  Box,
  SimpleGrid,
  Text,
  Flex,
  Icon,
  Spinner,
  useToast,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Input,
  Select,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import {
  FiActivity,
  FiDollarSign,
  FiUsers,
  FiTrendingUp,
  FiTrendingDown,
  FiCopy,
} from "react-icons/fi";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";
import { api_url } from "../../url";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";
import Pagination from "../../Components/Common/Pagination";

const StatCard = ({ label, value, icon, color, subtext }) => (
  <Box
    bg="white"
    p={6}
    borderRadius="lg"
    boxShadow="sm"
    border="1px solid"
    borderColor="gray.100"
  >
    <Flex justify="space-between" align="start">
      <Box>
        <Text fontSize="sm" color="gray.500" mb={1}>
          {label}
        </Text>
        <Text fontSize="2xl" fontWeight="bold" color="gray.700">
          {value}
        </Text>
        {subtext && (
          <Text
            fontSize="xs"
            color={subtext.includes("-") ? "red.500" : "green.500"}
          >
            {subtext}
          </Text>
        )}
      </Box>
      <Box p={3} bg={`${color}.50`} borderRadius="md">
        <Icon as={icon} boxSize={6} color={`${color}.500`} />
      </Box>
    </Flex>
  </Box>
);

const SportsGameReport = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const SIDEBAR_WIDTH = "240px";

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const tempToken = localStorage.getItem("token");
      const response = await axios.get(
        `${api_url}/analytics/stats?category=sports`,
        {
          headers: { Authorization: `Bearer ${tempToken}` },
        },
      );
      if (response.data.success) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching analytics:", error);
      toast({
        title: "Error fetching data",
        status: "error",
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  if (loading) {
    return (
      <Flex justify="center" align="center" h="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  const { summary, daily, recentWins } = data || {};

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        p={{ base: 4, md: 8 }}
        bg="gray.50"
        minH="100vh"
        mt="64px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
      >
        {/* <Text fontSize="2xl" fontWeight="bold" mb={6} color="gray.800">
                    Sports Game Reports
                </Text> */}

        {/* Summary Cards */}
        {/* <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={8}>
                    <StatCard
                        label="Gross Gaming Revenue (GGR)"
                        value={`₹${summary?.ggr?.toFixed(2) || "0.00"}`}
                        icon={FiActivity}
                        color="purple"
                        subtext="Net Revenue"
                    />
                    <StatCard
                        label="Total Bets"
                        value={`₹${summary?.totalBetAmount?.toFixed(2) || "0.00"}`}
                        icon={FiTrendingUp}
                        color="blue"
                        subtext={`${summary?.totalBetsCount || 0} rounds`}
                    />
                    <StatCard
                        label="Total Wins (Payouts)"
                        value={`₹${summary?.totalWinAmount?.toFixed(2) || "0.00"}`}
                        icon={FiTrendingDown}
                        color="orange"
                        subtext={`${summary?.totalWinsCount || 0} wins`}
                    />
                    <StatCard
                        label="Active Users"
                        value={summary?.activeUsers || 0}
                        icon={FiUsers}
                        color="green"
                        subtext="In selected period"
                    />
                </SimpleGrid> */}

        {/* Charts */}
        {/* <Box
                    bg="white"
                    p={6}
                    borderRadius="lg"
                    boxShadow="sm"
                    mb={8}
                    border="1px solid"
                    borderColor="gray.100"
                >
                    <Text fontSize="lg" fontWeight="bold" mb={4}>
                        Daily Volume
                    </Text>
                    <Box h="300px">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={daily}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="betAmount" name="Bets" fill="#3182ce" />
                                <Bar dataKey="winAmount" name="Wins" fill="#dd6b20" />
                                <Bar dataKey="ggr" name="GGR" fill="#805ad5" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Box>
                </Box> */}

        {/* Recent High Wins */}
        {/* <Box
                    bg="white"
                    borderRadius="lg"
                    boxShadow="sm"
                    border="1px solid"
                    borderColor="gray.100"
                    overflow="hidden"
                >
                    <Box p={4} borderBottom="1px solid" borderColor="gray.100">
                        <Text fontSize="lg" fontWeight="bold">
                            Recent High Wins
                        </Text>
                    </Box>
                    <Table variant="simple">
                        <Thead bg="gray.50">
                            <Tr>
                                <Th>User</Th>
                                <Th>Game</Th>
                                <Th>Amount</Th>
                                <Th>Time</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {recentWins?.map((win) => (
                                <Tr key={win._id}>
                                    <Td>
                                        <Flex align="center" gap={2}>
                                            <Icon as={FiUsers} color="gray.400" />
                                            <Text fontWeight="medium">
                                                {win.user?.username || "Unknown"}
                                            </Text>
                                        </Flex>
                                    </Td>
                                    <Td>{win.description || "Sports Game"}</Td>
                                    <Td fontWeight="bold" color="green.500">
                                        +₹{win.amount?.toFixed(2)}
                                    </Td>
                                    <Td color="gray.500">
                                        {new Date(win.createdAt).toLocaleString()}
                                    </Td>
                                </Tr>
                            ))}
                            {(!recentWins || recentWins.length === 0) && (
                                <Tr>
                                    <Td colSpan={4} textAlign="center" py={4} color="gray.500">
                                        No recent big wins
                                    </Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                </Box> */}

        {/* All Transactions Table */}
        <TransactionTable category="sports" />
      </Box>
    </>
  );
};

const TransactionTable = ({ category }) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("all_time");
  const toast = useToast();

  const fetchTransactions = async (
    pageVal = 1,
    searchVal = search,
    startVal = startDate,
    endVal = endDate,
  ) => {
    setLoading(true);
    try {
      const tempToken = localStorage.getItem("token");
      const response = await axios.get(
        `${api_url}/analytics/game-transactions`,
        {
          params: {
            category,
            page: pageVal,
            limit: limit,
            search: searchVal,
            startDate: startVal,
            endDate: endVal,
          },
          headers: { Authorization: `Bearer ${tempToken}` },
        },
      );
      if (response.data.success) {
        setTransactions(response.data.transactions);
        setTotalPages(response.data.pagination.pages);
        setTotalTransactions(response.data.pagination.total);
        setPage(response.data.pagination.page);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      // toast({
      //     title: "Error fetching transactions",
      //     status: "error",
      //     duration: 3000,
      // });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions(1, search, startDate, endDate);
  }, [category]); // Initial fetch

  const handleSearch = (e) => {
    setSearch(e.target.value);
    fetchTransactions(1, e.target.value, startDate, endDate);
  };

  const handlePeriodChange = (e) => {
    const period = e.target.value;
    setSelectedPeriod(period);

    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth();
    const d = now.getDate();

    const format = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    let start = "";
    let end = "";

    if (period === "today") {
      start = format(now);
      end = format(now);
    } else if (period === "yesterday") {
      const yday = new Date(y, m, d - 1);
      start = format(yday);
      end = format(yday);
    } else if (period === "this_week") {
      const day = now.getDay() || 7;
      const monday = new Date(y, m, d - day + 1);
      start = format(monday);
      end = format(now);
    } else if (period === "last_week") {
      const day = now.getDay() || 7;
      const lastSunday = new Date(y, m, d - day);
      const lastMonday = new Date(y, m, d - day - 6);
      start = format(lastMonday);
      end = format(lastSunday);
    } else if (period === "this_month") {
      start = format(new Date(y, m, 1));
      end = format(now);
    } else if (period === "last_month") {
      start = format(new Date(y, m - 1, 1));
      end = format(new Date(y, m, 0));
    } else if (period === "all_time") {
      start = "";
      end = "";
    } else if (period === "custom") {
      setStartDate("");
      setEndDate("");
      return;
    }

    setStartDate(start);
    setEndDate(end);
    fetchTransactions(1, search, start, end);
  };

  const handleCustomDateChange = (type, value) => {
    let newStart = startDate;
    let newEnd = endDate;
    if (type === "start") {
      setStartDate(value);
      newStart = value;
    } else {
      setEndDate(value);
      newEnd = value;
    }

    if (newStart && newEnd) {
      fetchTransactions(1, search, newStart, newEnd);
    }
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    fetchTransactions(1, search, startDate, endDate, newLimit);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast({
      title: "Copied to clipboard",
      status: "success",
      duration: 2000,
      isClosable: true,
      position: "top-right",
    });
  };

  return (
    <>
      <Flex justify="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold" color="#344767">
          Sports Game Reports
        </Text>
      </Flex>

      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        mb={4}
        align={{ base: "flex-start", md: "center" }}
        gap={4}
      >
        {/* Date Filter */}
        <Flex gap={2} align="center" wrap="wrap">
          <Select
            value={selectedPeriod}
            onChange={handlePeriodChange}
            size="md"
            maxW="200px"
            bg="white"
            borderColor="gray.200"
            _hover={{ borderColor: "gray.300" }}
          >
            <option value="all_time">All Time</option>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="this_week">This Week</option>
            <option value="last_week">Last Week</option>
            <option value="this_month">This Month</option>
            <option value="last_month">Last Month</option>
            <option value="custom">Custom Range</option>
          </Select>

          {selectedPeriod === "custom" && (
            <Flex align="center" gap={2}>
              <Input
                type="date"
                value={startDate}
                onChange={(e) =>
                  handleCustomDateChange("start", e.target.value)
                }
                minW="130px"
                maxW="160px"
                bg="white"
                size="md"
              />
              <Text color="gray.500">-</Text>
              <Input
                type="date"
                value={endDate}
                onChange={(e) => handleCustomDateChange("end", e.target.value)}
                minW="130px"
                maxW="160px"
                bg="white"
                size="md"
              />
            </Flex>
          )}
        </Flex>

        {/* Search Bar */}
        <InputGroup maxW={{ base: "100%", md: "350px" }}>
          <Input
            placeholder="Search user, id..."
            value={search}
            onChange={handleSearch}
            bg="white"
            borderRadius="md"
            borderColor="gray.200"
            _hover={{ borderColor: "gray.300" }}
            _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px #3182ce" }}
          />
          <InputRightElement pointerEvents="none" color="gray.400">
            <SearchIcon />
          </InputRightElement>
        </InputGroup>
      </Flex>

      <Box
        bg="white"
        borderRadius="12px"
        boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
        overflow="hidden"
        border="1px solid #f0f2f5"
      >
        <div style={{ overflowX: "auto" }}>
          <Table variant="simple">
            <Thead bg="#1f15da">
              <Tr>
                <Th color="white" fontSize="xs" py={4} border="none">
                  ID
                </Th>
                <Th color="white" fontSize="xs" py={4} border="none">
                  DATE & TIME
                </Th>
                <Th color="white" fontSize="xs" py={4} border="none">
                  USER
                </Th>
                <Th color="white" fontSize="xs" py={4} border="none">
                  OPERATION / DESCRIPTION
                </Th>
                <Th color="white" fontSize="xs" py={4} border="none">
                  BEFORE BALANCE
                </Th>
                <Th color="white" fontSize="xs" py={4} border="none">
                  AMOUNT
                </Th>
                <Th color="white" fontSize="xs" py={4} border="none">
                  AFTER BALANCE
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {loading ? (
                <Tr>
                  <Td colSpan={7} textAlign="center" py={8}>
                    <Spinner />
                  </Td>
                </Tr>
              ) : transactions.length > 0 ? (
                transactions.map((tx) => (
                  <Tr key={tx.id} _hover={{ bg: "#f8f9fa" }}>
                    <Td fontSize="xs" color="#67748e" py={4}>
                      <Flex align="center" gap={2}>
                        {tx.transactionId || tx.id}
                        <Icon
                          as={FiCopy}
                          cursor="pointer"
                          onClick={() => handleCopy(tx.transactionId || tx.id)}
                          _hover={{ color: "blue.500" }}
                        />
                      </Flex>
                    </Td>
                    <Td fontSize="xs" color="#67748e" py={4}>
                      {new Date(tx.dateTime).toLocaleString()}
                    </Td>
                    <Td py={4}>
                      <Badge colorScheme="purple">{tx.user}</Badge>
                    </Td>
                    <Td py={4}>
                      <Badge
                        variant="subtle"
                        colorScheme={
                          tx.operation?.toLowerCase().includes("win")
                            ? "green"
                            : tx.operation?.toLowerCase().includes("bet")
                              ? "red"
                              : "gray"
                        }
                        borderRadius="30px"
                        px={3}
                        textTransform="capitalize"
                      >
                        {tx.operation}
                      </Badge>
                    </Td>
                    <Td fontSize="sm" fontWeight="bold" color="#344767" py={4}>
                      ₹{tx.beforeBalance?.toFixed(2) || "0.00"}
                    </Td>
                    <Td
                      fontWeight="bold"
                      py={4}
                      whiteSpace="nowrap"
                      color={
                        tx.afterBalance - tx.beforeBalance > 0
                          ? "green.500"
                          : tx.afterBalance - tx.beforeBalance < 0
                            ? "red.500"
                            : "#67748e"
                      }
                    >
                      {tx.afterBalance - tx.beforeBalance > 0
                        ? "+"
                        : tx.afterBalance - tx.beforeBalance < 0
                          ? "-"
                          : ""}
                      ₹{tx.amount?.toFixed(2)}
                    </Td>
                    <Td fontSize="sm" fontWeight="bold" color="#344767" py={4}>
                      ₹{tx.afterBalance?.toFixed(2)}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={7} textAlign="center" py={8} color="gray.500">
                    No transactions found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </div>
        {/* Pagination */}
        <Pagination 
          currentPage={page}
          totalPages={totalPages}
          totalEntries={totalTransactions}
          limit={limit}
          onPageChange={(newPage) => fetchTransactions(newPage, search, startDate, endDate)}
          onLimitChange={handleLimitChange}
        />
      </Box>
    </>
  );
};

export default SportsGameReport;
